"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgEmailFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M2.043 5.454l8.544 8.55c.47.389.941.583 1.413.583.472 0 .943-.193 1.415-.581L21.96 5.47c.027.163.041.34.041.529v12c0 1.333-.667 2-2 2H4c-1.333 0-2-.667-2-2V6a3.2 3.2 0 01.043-.546zm1.414-1.411A3.18 3.18 0 014 4h16c.194 0 .373.014.539.042L12 12.588 3.457 4.043z' }))); };
exports.default = SvgEmailFilled;
//# sourceMappingURL=EmailFilled.js.map